import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Note } from 'src/app/classes/models';
import { NoteService } from 'src/app/services/note.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-note-email-display-modal',
  templateUrl: './note-email-display-modal.component.html',
  styleUrl: './note-email-display-modal.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class NoteEmailDisplayModalComponent implements OnInit {
  constructor(
    private ActiveModal: NgbActiveModal,
    private ToastService: ToastService,
    private NoteService: NoteService,
    private ChangeDetectorRef: ChangeDetectorRef
  ) {}

  @Input() NoteId!: number;
  Note!: Note;

  close() {
    this.ActiveModal.dismiss();
  }

  ngOnInit(): void {
    if (!this.NoteId) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Missing note id information.',
        { returnError: true }
      );
    }

    this.NoteService.getNote({
      attributes: JSON.stringify(['note']),
      id: this.NoteId
    }).subscribe({
      next: (Note) => {
        this.Note = Note;
        this.ChangeDetectorRef.markForCheck();
      }
    });
  }
}
